import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function VM_table() {
  const data = [
    {
      sr: "01",
      period: "3.09",
      observation: "3.09",
      deviation: "2.09",
      standard: "0.1",
      typeB: "0.1",
      combined: "23.8",
      date: "1 JAN 2025 | 1.23 PM",
    },
  ];
     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Measurement Period</th>
                <th>Observation Value</th>
                <th>Standard Deviation</th>
                <th>Standard Uncertainity</th>
                <th>Type B Uncertainity</th>
                <th>Combined Uncertainity</th>
                <th>Date & Time</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.sr}</td>
                  <td>{row.period}</td>
                  <td>{row.observation}</td>
                  <td>{row.deviation}</td>
                  <td>{row.standard}</td>
                  <td>{row.typeB}</td>
                  <td>{row.combined}</td>
                  <td>{row.date}</td>
                  <td>
                    <div className="action_icons">
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}

export default VM_table;
